export default {
  0: 'Authing は、あらゆる Web、App、企業向けソフトウェアのためのアイデンティティとアクセス管理プラットフォームを提供し、あらゆる企業や開発者が最初から最後までビジネスの成功を達成できるようにサポートする。',
  1: '上海市都市建設情報技術有限会社は、都市インフラの建設と運営の産業チェーンのすべてのリンクにおける BIM 情報管理の市場需要を重視しており、全生活情報管理コンサルティングサービス、建設と運営の情報プラットフォームの製品開発と総合サービス、インテリジェント知覚インターネット・オブ・シングスシステムの設計と統合実装、ビッグデータ分析と人工知能の統合などの分野で、インテリジェントで情報ベースの製品とソリューションを創出している。',
  2: '顧客データを保護する場合でも、業務の効率化が必要な場合でも、Authing はお客様のニーズにお応える。 Authing のアイデンティティ ソリューションは、テクノロジー、教育、金融など幅広い業界を保護する。',
  3: '99.99%のシステム信頼性、最短5分でアクセス可能',
  4: '認証プラットフォームは8カ国から毎月何百万人もの人が認証のために呼び出されている',
  5: 'AWS は、アマゾン社が作成したクラウドコンピューティングプラットフォームで、IT インフラやアプリケーションなど様々なサービスを提供する。',
  6: '六王朝の古都である南京に位置する東南大学は、国内外で有名な大学である。',
  7: '1954年5月に設立された高等教育出版社は、新中国で最も早い時期に設立された専門的な教育出版機関の一つである。',
  我们的经典客户案例: '顧客ケース',
  查看详情: '詳しい情報へ>>',
  Authing助力企业发展: '事業成長のための Authing',
  了解详情: '詳しい情報へ',
  每月安全登录次数: '月間のセキュアログイン数',
};
